import { render } from "./FormView.vue?vue&type=template&id=b562c94e"
import script from "./FormView.vue?vue&type=script&lang=ts"
export * from "./FormView.vue?vue&type=script&lang=ts"
script.render = render

export default script